import { Component, Vue } from 'vue-property-decorator';
import UserDetailsStore from '@/store/modules/UserDetailsStoreModule';
import { UserDetailsStoreModule, TenantDetailsStoreModule } from '@/store';
import TenantDetailsStore from '@/store/modules/TenantDetailsStoreModule';
import { UserDetailsList, UserDetailsHeader, UserDetailsFilter } from '@/components/userDetails';
import { UserDetailsForm } from '@/common/viewModels';
import { ToastHelper, ErrorHelper } from '@/common/helpers';
import IAdminService from '@/services/http/interfaces/IAdminService';

@Component({
    components: {
        UserDetailsList,
        UserDetailsHeader,
        UserDetailsFilter,
    },
})
export default class UserDetails extends Vue {

    userDetails$: UserDetailsStore = UserDetailsStoreModule;
    tenantDetails$: TenantDetailsStore = TenantDetailsStoreModule;

    private adminService?: IAdminService;

    get tenantId(): string {
        return this.$route.params.tenantId;
    }

    get userId(): string {
        return this.$route.params.userId;
    }

    get tenantUserInviteError(): string {
        return this.userDetails$.tenantUserInviteError;
    }

    async mounted() {
        this.initServices();

        Promise.all([
            this.tenantDetails$.getTenantDetails({ adminService: this.$factory.createAdminService(), tenantId: this.$route.params.tenantId }),
            this.userDetails$.getUserDetails({ adminService: this.$factory.createAdminService(), tenantId: this.$route.params.tenantId, userId: this.userId }),
            this.userDetails$.getTenantUserInvitations({ adminService: this.$factory.createAdminService(), tenantId: this.$route.params.tenantId, userId: this.userId }),
        ]);
    }

    get editForm(): UserDetailsForm {
        return this.userDetails$.editForm;
    }

    initServices(): void {
        this.adminService = this.$factory.createAdminService();
    }

    async onSendInvitation(): Promise<void> {
        try {
            const isSuccess = await this.userDetails$.sendInvitation({ adminService: this.adminService!, tenantId: this.tenantId });
            if (isSuccess) {
                this.getTenantUserInvitations();
                ToastHelper.Notify('User invited', `The user ${this.userDetails$.userDetails.email} has been invited successfully.`);
            }
        } catch (error) {
            this.userDetails$.updateInviteTenantUserError(ErrorHelper.getMessageForError(error));
        }
    }

    async getTenantUserInvitations(): Promise<void> {
        await this.userDetails$.getTenantUserInvitations({ adminService: this.$factory.createAdminService(), tenantId: this.tenantId, userId: this.userId });
    }

    goBack(): void {
        this.$router.back();
    }

    filterChange(filter: string): void {
        this.userDetails$.setFilter(filter);
    }

    pageChange(page: number): void {
        this.userDetails$.setCurrentPage(page);
    }

    onEditUserFormInputChange(fieldName: string, value: any): void {
        this.userDetails$.editUserModalFormInputChange({ fieldName, value });
    }

    hideEditUserModal(): void {
        (this.$refs.userDetailsHeader as UserDetailsHeader).hideEditUserModal();
    }

    get tenantUserEditError(): string {
        return this.userDetails$.tenantUserEditError;
    }

    async onEditTenantUser(): Promise<void> {
        try {
            const isSuccess = await this.userDetails$.requestTenantUserEdit({ adminService: this.$factory.createAdminService(), tenantId: this.$route.params.tenantId });
            if (isSuccess) {
                this.hideEditUserModal();
                ToastHelper.Notify('User updated', `The user ${this.editForm.data.tenantUserEdit.email} has been updated successfully.`);
                await this.userDetails$.getUserDetails({ adminService: this.$factory.createAdminService(), tenantId: this.$route.params.tenantId, userId: this.$route.params.userId });
            }
        } catch (error) {
            this.userDetails$.updateEditTenantUserError(ErrorHelper.getMessageForError(error));
        }
    }

    async onSelectedUser(): Promise<void> {
        (this.$refs.userDetailsHeader as UserDetailsHeader).showEditUserModal();
    }
}
